import { useEffect, useState } from 'react';
import api from '../../hooks/useApi';

// Picking portal sections while creating a client or a contact, so onboarding
// is one form rather than a create followed by a second visit to switch things
// on.
//
// The list comes from the server rather than being written out here, because a
// second copy of it would drift the first time a section is added.
//
// `availableKeys` is how the contact form respects the client ceiling: a
// section the client does not have cannot be given to their people, so it is
// not offered at all rather than offered and then refused on save.
export default function SectionPicker({ value, onChange, availableKeys, label, hint }) {
  const [features, setFeatures] = useState(null);

  useEffect(() => {
    api.get('client-portal-access/features')
      .then(r => setFeatures(r.features))
      .catch(() => setFeatures([]));
  }, []);

  if (!features) return null;

  const offered = availableKeys
    ? features.filter(f => availableKeys.includes(f.key))
    : features;

  return (
    <div>
      <label className="block text-[8px] font-bold text-gray-400 uppercase tracking-wide mb-1">{label}</label>
      {offered.length === 0 ? (
        <div className="text-[9px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1.5">
          This client has no portal sections switched on, so there is nothing to give this contact yet.
        </div>
      ) : (
        <>
          <div className="flex flex-wrap gap-1.5">
            {offered.map(f => {
              const on = value.includes(f.key);
              return (
                <button key={f.key} type="button" title={f.blurb}
                  onClick={() => onChange(on ? value.filter(k => k !== f.key) : [...value, f.key])}
                  className={`border rounded-full px-3 py-1 text-[9px] font-bold ${
                    on ? 'bg-navy border-navy text-white' : 'bg-white border-gray-200 text-gray-500 hover:border-gray-300'
                  }`}>
                  {f.label}
                </button>
              );
            })}
          </div>
          {hint && <div className="text-[8px] text-gray-400 mt-1">{hint}</div>}
        </>
      )}
    </div>
  );
}
